import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';

import styles from './Error.module.scss';

export const GlobalError = ({ text }) => {
  const navigation = useNavigate();
  const ref = useRef(null);

  const handleClose = () => {
    ref?.current?.classList.remove('visible');
  };

  useEffect(() => {
    return () => {
      handleClose();
    };
  }, [navigation]);

  return (
    <div id={'global-error'} ref={ref} className={styles.errorContainer}>
      <div className={styles.errorText}>
        <h5>Error</h5>
        <p id='global-error-text'></p>
      </div>
      <div className={styles.cross} onClick={handleClose}>
        +
      </div>
    </div>
  );
};
